import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Select, Modal, Divider, Row, Col} from 'antd';
import {CommandDto, CommandDtoCheckStatusOptionEnum, LocateDto} from '../../../api';
import {CheckCircleOutlined, EditOutlined, FunctionOutlined} from "@ant-design/icons";
import DescriptionFormItem from "../../form/DescriptionFormItem";
import ExpressionBuilderModal from "../ExpressionBuilderModal";
import LocatorList from "./locator/LocatorList";
import {listToLocateDto, locateDtoToList} from "../../../utils/LocatorUtils";

const CheckStatusCommandModal = ({onCommandCardData, initialData}: { onCommandCardData: Function; initialData?: CommandDto }) => {
    const {Option} = Select;
    const [form] = Form.useForm();
    const [showCheckValue, setShowCheckValue] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false); // State für die Modal-Sichtbarkeit
    const [isExpressionBuilderVisible, setIsExpressionBuilderVisible] = useState(false);

    // Die Locators
    const [locatorData, setLocatorData] = useState<LocateDto[]>([]);


    useEffect(() => {
        if (initialData?.locateDto) {
            setLocatorData(locateDtoToList(initialData.locateDto));
        }
        if (initialData?.checkStatusOption) {
            onCheckStatusOptionChange(initialData.checkStatusOption);
            form.setFieldValue('checkStatusOption', initialData.checkStatusOption);
        }
        if (initialData?.executeValue) {
            form.setFieldValue('checkValue', initialData.executeValue);
        }
    }, [initialData]);


    const onFinish = (values) => {
        let locate: LocateDto = listToLocateDto(locatorData);


        let command: CommandDto = {
            locateDto: locate,
            commandType: 'CHECK_STATUS',
            checkStatusOption: values.checkStatusOption,
            checkStatusValue: values.checkValue,
            description: values.description
        };
        onCommandCardData(command);
        setIsModalVisible(false);// Modal schließen
    };

    const onReset = () => {
        form.resetFields();
    };

    const allStatusOptions = Object.values(CommandDtoCheckStatusOptionEnum);

    const allowedOptions = [
        CommandDtoCheckStatusOptionEnum.HasText,
        CommandDtoCheckStatusOptionEnum.HasValue,
        CommandDtoCheckStatusOptionEnum.HasClass,
        CommandDtoCheckStatusOptionEnum.ContainsText,
    ];

    const onCheckStatusOptionChange = (value) => {
        setShowCheckValue(allowedOptions.includes(value));
    };

    // Funktion zum Öffnen des Modals
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Funktion zum Schließen des Modals
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleOpenExpressionBuilder = () => {
        setIsExpressionBuilderVisible(true);
    };

    const handleExpressionBuilderCancel = () => {
        setIsExpressionBuilderVisible(false);
    };


    return (
        <>
            {initialData == null &&
                <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
                  <Button
                      type="primary"
                      onClick={showModal}
                      style={{width: '100%', height: '100%'}}
                  >
                    <CheckCircleOutlined/> Zustand prüfen
                  </Button>
                </div>}
            {initialData != null &&
                <Button
                    type="primary"
                    style={{float: 'right'}}
                    onClick={showModal}
                >
                  <EditOutlined/>
                </Button>
            }
            <Modal
                title="Zustandsprüfung"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={800}
            >
                <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <LocatorList locateDtoList={locatorData} onChange={setLocatorData}/>
                    <Divider/>
                    <Form.Item name="checkStatusOption" label="Prüfoption" rules={[{required: true, message: 'Bitte wähle eine Prüfoption aus'}]}>
                        <Select
                            placeholder="Selektiere eine Prüfoption"
                            onChange={onCheckStatusOptionChange}
                            allowClear
                        >
                            {allStatusOptions.map((option) => (
                                <Option key={option} value={option}>
                                    {option}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {showCheckValue && (
                        <Form.Item name="checkValue" label="Prüfwert" rules={[{required: true, message: 'Bitte gebe einen Prüfwert ein'}]}>
                            <Input addonAfter={<Button onClick={handleOpenExpressionBuilder}><FunctionOutlined/></Button>}/>
                        </Form.Item>
                    )}
                    <DescriptionFormItem/>
                    <Form.Item>
                        <Row justify="center">
                            <Col style={{marginRight: 5}}>
                                <Button type="primary" htmlType="submit">
                                    {initialData ? "Speichern" : "Hinzufügen"}
                                </Button>
                            </Col>
                            <Col>
                                <Button htmlType="button" onClick={onReset}>
                                    Zurücksetzen
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <ExpressionBuilderModal
                    isVisible={isExpressionBuilderVisible}
                    onSave={(expression) => {
                        form.setFieldValue('checkValue', expression)
                    }}
                    handleCancel={handleExpressionBuilderCancel}
                />
            </Modal>
        </>
    );
};

export default CheckStatusCommandModal;
